// extracted by mini-css-extract-plugin
module.exports = {"underlineContainer":"style-module__underlineContainer___2YVJz","underline":"style-module__underline___3SEme"};